import jQuery from 'jquery';
import _ from 'lodash';

const { UI } = Mobi2Go;
const { Order } = Mobi2Go;
const { Menu } = Mobi2Go;

/**-------------------------------------------------------------------------
 * Allow locations to automatically show on page load with query string
 */
Mobi2Go.Order.onReady(function() {
    if ('locations' in Mobi2Go.helpers.getQueryStringAsObject()) {
        UI.trigger('showLocations');
    }
});

/**-------------------------------------------------------------------------
 * Allow locations to automatically show on page load with query string
 */
Order.onReady(function() {
    const query = Mobi2Go.helpers.getQueryStringAsObject();

    if (Order.getProgressPhase() !== 'unconfirmed') {
        return;
    }

    _.delay(function() {
        // Delay to give some time for page to settle
        if ('category' in query) {
            UI.trigger('showCategory', query.category);
            UI.trigger('scrollToCategory', query.category);

            // Will highlight any custom menu category elements
            jQuery(`[data-m2g-show-menu-category="${query.category}"]`).click();
        }

        if ('product' in query) {
            let menu_product = null;

            // Prefer active menu product
            menu_product = Order.getMenu().getProductByName(query.product);
            if (!menu_product) {
                menu_product = Menu.getProducts().getByName(query.product);
            }

            if (menu_product) {
                if (query.open_product) {
                    UI.trigger(
                        'editProduct',
                        menu_product.createOrderProductInstance()
                    );
                } else {
                    UI.trigger('scrollToProduct', menu_product.id);
                }
            }
        }
    }, 500);
});
